import App from './App'
import ReactDOM from "react-dom"
import "./styles.css"

ReactDOM.render(<App />, document.getElementById("root"))

